// ============================================================
//  PMG BOOKS — DATA FILE
//  To add/edit books → update the arrays below.
//  Replace pdfUrl with your actual hosted PDF link.
//  Replace coverUrl with your actual book cover image.
// ============================================================

export const OTHER_AUTHORS_BOOKS = [
  {
    id: 1,
    title: "The Intelligent Investor",
    author: "Benjamin Graham",
    category: "Investing",
    description: "The definitive book on value investing. A roadmap for every investor — from beginner to expert.",
    coverColor: "#1a2744",
    accentColor: "#C9A84C",
    pages: 640,
    year: 2003,
    pdfUrl: "/books/intelligent-investor.pdf", // replace with real URL
    previewUrl: "/books/previews/intelligent-investor-preview.pdf",
  },
  {
    id: 2,
    title: "Rich Dad Poor Dad",
    author: "Robert T. Kiyosaki",
    category: "Financial Literacy",
    description: "What the rich teach their kids about money that the poor and middle class do not.",
    coverColor: "#8B1A1A",
    accentColor: "#E8C97A",
    pages: 336,
    year: 2000,
    pdfUrl: "/books/rich-dad-poor-dad.pdf",
    previewUrl: "/books/previews/rich-dad-preview.pdf",
  },
  {
    id: 3,
    title: "Mastering Bitcoin",
    author: "Andreas M. Antonopoulos",
    category: "Crypto & Web3",
    description: "The essential guide to the world of Bitcoin and blockchain for developers and enthusiasts.",
    coverColor: "#0D2137",
    accentColor: "#F7931A",
    pages: 416,
    year: 2017,
    pdfUrl: "/books/mastering-bitcoin.pdf",
    previewUrl: "/books/previews/mastering-bitcoin-preview.pdf",
  },
  {
    id: 4,
    title: "The Psychology of Money",
    author: "Morgan Housel",
    category: "Behavioural Finance",
    description: "Timeless lessons on wealth, greed, and happiness. How your relationship with money shapes every financial decision.",
    coverColor: "#1C3A2A",
    accentColor: "#4CAF7D",
    pages: 256,
    year: 2020,
    pdfUrl: "/books/psychology-of-money.pdf",
    previewUrl: "/books/previews/psychology-preview.pdf",
  },
  {
    id: 5,
    title: "Web3: Charting the Internet's Next Economic & Cultural Frontier",
    author: "Alex Tapscott",
    category: "Web3",
    description: "A comprehensive map of the decentralised future — blockchain, NFTs, DAOs and the creator economy.",
    coverColor: "#1A0D37",
    accentColor: "#9B59B6",
    pages: 320,
    year: 2023,
    pdfUrl: "/books/web3-tapscott.pdf",
    previewUrl: "/books/previews/web3-preview.pdf",
  },
  {
    id: 6,
    title: "Think and Grow Rich",
    author: "Napoleon Hill",
    category: "Mindset",
    description: "The classic guide to developing a success mindset. The 13 principles that built some of the world's greatest fortunes.",
    coverColor: "#2A1A0A",
    accentColor: "#C9A84C",
    pages: 288,
    year: 1937,
    pdfUrl: "/books/think-and-grow-rich.pdf",
    previewUrl: "/books/previews/think-grow-rich-preview.pdf",
  },
];

export const BOOK_CATEGORIES = [
  "All",
  "Investing",
  "Crypto & Web3",
  "Financial Literacy",
  "Behavioural Finance",
  "Web3",
  "Mindset",
];
